import React from 'react';

export interface IProps {
  fillColor?: string;
}

const BigArrowIcon: React.FC<IProps> = (props) => {
  return (
    <svg width="24" height="39" viewBox="0 0 24 39" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.6025 38.048C1.25056 37.7267 0.971371 37.34 0.782036 36.913C0.592699 36.486 0.497185 36.0267 0.501308 35.5635C0.485554 34.6432 0.846735 33.7521 1.50865 33.079L15.2733 19.4969L1.50865 5.9178C0.845825 5.24526 0.484495 4.35379 0.501308 3.43334C0.493814 2.97716 0.588167 2.52482 0.777937 2.10559C0.967707 1.68637 1.24862 1.31076 1.6025 1.00173C2.30371 0.353068 3.24667 -0.00667419 4.22616 0.000480977C5.20566 0.00763615 6.14243 0.380215 6.83303 1.03904L22.9914 17.059C23.6396 17.7225 24 18.5924 24 19.4969C24 20.4013 23.6396 21.2713 22.9914 21.9347L6.83631 37.9547C6.49096 38.2925 6.07642 38.5586 5.61791 38.7383C5.1594 38.9179 4.66686 39.0076 4.17084 38.9995C3.21724 39.0085 2.29687 38.6679 1.6025 38.048Z" fill={props.fillColor ?? "#BDBDBD"} />
    </svg>
  )
}

export default BigArrowIcon;